import { createMasterApprove, createMasterEvent, createMasterRoom, getAllFloor, getSingleMasterApproved, getSingleMasterRoom, handleKeyDown, updateMasterApproved, updateMasterRoom } from "_services";
import {
  CommonDate,
  CommonDatePicker,
  CommonInput,
  CommonModal,
  CustomSelect,
} from "components";
import { createEvent } from "features/masterService";
import { errorSchema, utils } from "helper";
import React, { useEffect, useMemo, useRef, useState } from "react";
import toast from "react-hot-toast";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

const AddApprovedByModal = (props) => {
  const [form, setForm] = useState({
    name: "",
  
  });
  const [initialForm, setInitialForm] = useState({
    name: "",
    
  });
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const nameRef = useRef()
  const startRef = useRef()
  const endRef = useRef()
  const [formError, setFormError] = useState("");
const [isLoading,setIsLoading] = useState(false)
const [allFloorList,setAllFloorList] = useState([])


useEffect(() => {
  if (props?.addressId) {
    getRoomDetails(props?.addressId);
  }
}, [props?.addressId]);

useEffect(() => {
  if (startRef.current) {
    startRef.current.focus(); 
  }
}, []);


const getRoomDetails = async (id) => {
  try {
    const res = await getSingleMasterApproved(id);

    if (res?.status === 200) {
      const eventData = {
        name: res?.results?.name,
       
      };
      setForm(eventData);
      setInitialForm(eventData); 
      
    }
  } catch (error) {}
};


  const handleOnChange = async (name, value) => {
    setForm((prevForm) => {
      const updatedForm = {
        ...prevForm,
        [name]: value,
      };

      if (formError) {
        utils
          .checkFormError(
            {
              ...updatedForm,
            },
            errorSchema.approveSchema
          )
          .then((validationResult) => {
            if (validationResult === true) {
              setFormError("");
            } else {
              setFormError(validationResult);
            }
          });
      }

      return updatedForm;
    });
  };

  const handleSubmit = async () => {
    const validationResult = await utils?.checkFormError(
      form,
      errorSchema.approveSchema
    );
    const payload = {}

    Object.keys(form).map((item, index) => {
      if (form[item] !== initialForm[item]) {
        payload[item] = form[item];
      }
    });

    if (validationResult === true) {
        
        try {
          setIsLoading(true)
          if (props?.addressId) {
            const res = await updateMasterApproved({
              payload,
              id: props?.addressId,
            });
  
           
            if (res.status === 200) {
              setIsLoading(false)
              toast.success(res.message);
              props?.closeModal();
              props?.callBackFunc();
            }else{
              toast.error(res.error);
            }

          } else {
            const res = await createMasterApprove(payload);
         
            if (res.status === 201) {
                setIsLoading(false)
                toast.success(res.message);
                props?.closeModal();
                props?.callBackFunc();
                
              }else{
                toast.error(res.error);
              }
            }
            } catch (error) {
              setIsLoading(false)
            }
      }else{
        setFormError(validationResult)
      }
    
  };

  const objectBid = {
    ...props,
    onSubmit: handleSubmit,
    disabled:isLoading || props?.eventView,
    isLoadding:isLoading
  };

  const handleKey = (e, name,nextInputRef) => {
    if (e.key === "Enter") {
      e.preventDefault();
      if (nextInputRef) {
        nextInputRef.current.focus(); 
      } else {
        handleSubmit(e);
      }
    } else if (e.key === "ArrowUp" || e.key === "ArrowDown") {
        e.preventDefault();
      }
  };

  return (
    <>
      <CommonModal {...objectBid}>
        <div className="_plcMod_body" style={{ padding: "20px" }}>
          <div className="flxInr">
            
            <div className="singleDiv">
            <CommonInput
               type="text"
                label="Name"
                placeholder="Enter Name"
                name="name"
                value={form?.name}
                onChange={({ target: { name, value } }) => {
                  handleOnChange(name, value);
                }}
                focus={!!formError?.name}
                error={formError.name}
                ref={startRef}
                onKeyDown={(e) => handleKey(e, "room_number", null)}
                // onKeyPress={handleKeyDown}
                disabled={props?.eventView}
              />
            </div>
            <div className="singleDiv">
              
            </div>
          </div>
        </div>
      </CommonModal>
      <div className="offBack_drop"></div>
    </>
  );
};

export default AddApprovedByModal;
